import React from 'react';
import MessageInputBox from './MessageInputBox';
import { CommonElementId } from '../Common/constants';
const AlmeInput = (props) => {
    return (React.createElement(MessageInputBox, Object.assign({ id: CommonElementId.MessageInputBox, ariaLabel: 'Send a new message', inputClassName: "iva-text-input-field", onSend: props.submitFunc, sendButtonLabel: props.almeAppConfig.footer.submitButtonText, maxTextLength: props.almeAppConfig.footer.maxInputLength }, props.focusProps, { isLiveChatConnected: props.isLiveChatConnected, onSendTypingEvent: props.onSendTypingEvent, almeAppConfig: props.almeAppConfig })));
};
export default AlmeInput;
